import type React from 'react'
import { CROP_ACCENT_COLOR } from '../constants/crop-chrome'
import type { CropVisualRect } from '../helpers/badge-layout'

interface CropFrameProps {
  visual: CropVisualRect
  /** Stroke width (canvas units). */
  sw: number
  onPanDown: (e: React.PointerEvent) => void
  onPointerMove: (e: React.PointerEvent) => void
  onPointerUp: (e: React.PointerEvent) => void
}

/** The crop frame: a draggable interior that pans the photo, and the frame border. */
export function CropFrame({ visual, sw, onPanDown, onPointerMove, onPointerUp }: CropFrameProps) {
  const { x: vx, y: vy, width: vw, height: vh } = visual

  return (
    <>
      {/* Interior — click and drag to pan the photo within the frame. Sized to the VISUAL
        rect so the draggable area matches what's actually drawn (see the visual-rect
        comment in crop-overlay.tsx); the pan math itself still reads the geometric frame size. */}
      <rect
        x={vx}
        y={vy}
        width={vw}
        height={vh}
        fill="transparent"
        style={{ pointerEvents: 'all', cursor: 'move' }}
        onPointerDown={onPanDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
      />

      {/* Frame border — drawn at the visual rect, matching normal selection chrome. */}
      <rect
        x={vx}
        y={vy}
        width={vw}
        height={vh}
        fill="none"
        stroke={CROP_ACCENT_COLOR}
        strokeWidth={sw}
        vectorEffect="non-scaling-stroke"
        pointerEvents="none"
      />
    </>
  )
}
